import axios from "axios";
const token = window.localStorage.getItem("token");
const config = {
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        Authorization: `${token}`
    }
};
// const baseURL = process.env.REACT_APP_API_URL;
import secureLocalStorage from "react-secure-storage";
const baseURL = secureLocalStorage.getItem("baseURL");
export const get_all_log_types = async () => {
    let response = await axios.get(baseURL + "/api/log-types", config);
    return response.data.data;
}
export const update_log_types = async (log_type_id, name) => {
    let response = await axios.patch(baseURL + "/api/log-types/" + log_type_id, {
        "name": name,
    }, config);
    return response.data.data;
}
export const delete_log_type = async (log_type_id) => {
    let response = await axios.delete(baseURL + "/api/log-types/" + log_type_id, config);
    return response.data.data;
}